import { render, staticRenderFns } from "./Measurement.vue?vue&type=template&id=2e1e70a9&scoped=true&"
import script from "./Measurement.vue?vue&type=script&lang=js&"
export * from "./Measurement.vue?vue&type=script&lang=js&"
import style0 from "./Measurement.vue?vue&type=style&index=0&id=2e1e70a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1e70a9",
  null
  
)

export default component.exports